export const BIO_SECTIONS = [
  { key: "buyers", label: "Your buyers", pro: false },
  { key: "history", label: "Past Buyer Want-Listings", pro: false },
  { key: "markets", label: "Where you work", pro: false },
  { key: "links", label: "Website, socials and video", pro: true },
  { key: "testimonials", label: "Client testimonials", pro: true },
];

export const DEFAULT_ORDER = BIO_SECTIONS.map((section) => section.key);

export const resolveLayout = (layout) => {
  const keys = new Set(DEFAULT_ORDER);
  const seen = new Set();
  const order = (Array.isArray(layout?.order) ? layout.order : []).filter(
    (key) => keys.has(key) && !seen.has(key) && seen.add(key),
  );
  DEFAULT_ORDER.forEach((key) => {
    if (!seen.has(key)) order.push(key);
  });
  return { order };
};
